/**=========================================================
 * Module: profile.js
 * Profile Controller
 =========================================================*/
App.controller('ProfileController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R) {
    "use strict";
    
      $scope.model = {};
      
      $scope.load = function(){
        R.one('account','me').get().then(
            function(account){
                $scope.model = account;
            }
        );  
      };
      
      $scope.load();
      
      $scope.save = function(){
        $scope.model.put();
      };
      
      $scope.newPwd = function(){
        if($scope.password && $scope.newPassword && $scope.newPassword==$scope.newPassword2){
            $scope.model.put({ jsonData: { password: $scope.password, newPassword: $scope.newPassword }});
        }
      };
  }
  ]);